import { useEffect, useState } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet.heat";
import api from "../services/api";

function HeatLayer({ points }) {
  const map = useMap();

  useEffect(() => {
    if (!map || points.length === 0) return;

    const heat = L.heatLayer(points, {
      radius:  25,
      blur:    15,
      maxZoom: 17,
      gradient: {
        0.2: "#0B3C5D",
        0.5: "#FFA500",
        0.8: "red",
        1.0: "white",
      },
    }).addTo(map);

    return () => map.removeLayer(heat);

  }, [map, points]);

  return null;
}

export default function HeatmapPage() {
  const [points,  setPoints]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [total,   setTotal]   = useState(0);

  const fetchHeat = async () => {
    try {
      setLoading(true);
      const res = await api.get("/admin/heatmap");
      const formatted = res.data.map(p => [
        parseFloat(p.latitude),
        parseFloat(p.longitude),
        Math.min((p.weight ?? 1) / 10, 1), // intensité normalisée
      ]);
      setPoints(formatted);
      setTotal(res.data.length);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => { fetchHeat(); }, []);

  return (
    <div style={{ padding: "1.5rem 0" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.5rem" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" }}>🔥 Heatmap Activité</h1>
          <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>Zones les plus actives — Saint-Louis</p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ fontSize: 12, padding: "4px 14px", borderRadius: 20, background: "#E6F1FB", color: "#185FA5", border: "0.5px solid #B5D4F4" }}>
            📍 {total} points
          </div>
          <button onClick={fetchHeat} style={{
            fontSize: 12, padding: "6px 14px", borderRadius: 20, cursor: "pointer",
            border: "0.5px solid #ccc", background: "#fff", color: "#888",
          }}>
            🔄 Actualiser
          </button>
        </div>
      </div>

      {/* Légende */}
      <div style={{ display: "flex", gap: 16, marginBottom: 12, alignItems: "center" }}>
        <span style={{ fontSize: 12, color: "#888" }}>Intensité :</span>
        {[
          ["#0B3C5D", "Faible"],
          ["#FFA500", "Moyenne"],
          ["red",     "Forte"],
          ["white",   "Très forte"],
        ].map(([color, label]) => (
          <div key={label} style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <div style={{ width: 14, height: 14, borderRadius: "50%", background: color, border: "0.5px solid #ccc" }} />
            <span style={{ fontSize: 12, color: "#888" }}>{label}</span>
          </div>
        ))}
      </div>

      {/* Carte */}
      {loading ? (
        <div style={{ height: "75vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f7f7f7", borderRadius: 12 }}>
          <p style={{ color: "#888" }}>Chargement des données...</p>
        </div>
      ) : (
        <div style={{ borderRadius: 12, overflow: "hidden", border: "0.5px solid #e5e5e5" }}>
          <MapContainer
            center={[16.0179, -16.4896]}
            zoom={13}
            style={{ height: "75vh", width: "100%" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; OpenStreetMap'
            />
            <HeatLayer points={points} />
          </MapContainer>
        </div>
      )}

      {/* Info */}
      {!loading && points.length === 0 && (
        <p style={{ textAlign: "center", color: "#aaa", marginTop: 20 }}>
          Aucune donnée disponible — les courses apparaîtront ici
        </p>
      )}

    </div>
  );
}